import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Modal, FormGroup } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as action from '../../Pages/Library/ColorLibary/store/ColorLibrary.action';
import * as supportingAction from './store/SupportingDocument.action';
import Loader from '../Utility/Loader/Loader';
import { customStyles } from '../helper';

function EditSupportingDocument({ show, data, handlePopup, fromColourLibrary, devOrderId, referenceOptions }) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [reference, setReference] = useState(null);
  const [placement, setPlacement] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const reducerData = useSelector((reducerState) => reducerState);
  const { SystemMastersDetails } = reducerData;
  const { placement_master } = SystemMastersDetails;
  const fileName = data?.fileName;
  const fileExtn = data.fileName.substr(data.fileName.lastIndexOf('.') + 1);

  useEffect(() => {
    setValue('fileName', fileName);
    setValue('fileExtn', fileExtn);
    setPlacement(placement_master?.find((item) => item?._id === data?.placement));
    setReference(data?.reference);
  }, [fileName, fileExtn, setValue]);

  const onSubmit = async (obj) => {
    if (fromColourLibrary) {
      setShowLoader(true);
      const params = {
        libId: data?._id,
        fileName: obj?.fileName,
      };
      const res = await dispatch(action.editColorSupportingDocs(params, t));
      setShowLoader(false);
      if (res) {
        handlePopup(true);
      }
    } else {
      const params = {
        fileName: data?.documentType === 'link' ? obj?.fileName : `${obj?.fileName?.trim()}`,
        id: data._id,
        placement: placement?._id || '',
        reference: JSON.stringify(reference) || '',
      };
      if (devOrderId) {
        params.devOrderId = devOrderId;
      }
      await setShowLoader(true);
      const res = await dispatch(supportingAction.updateDocuments(params, t));
      await setShowLoader(false);
      if (res) {
        handlePopup(true);
      }
    }
  };

  const handleReference = (ele) => {
    setReference(ele);
  };

  const handlePlacement = (ele) => {
    setPlacement(ele);
  };

  const validReferenceOptions = useMemo(() => {
    if (referenceOptions?.length) {
      return referenceOptions.some((option) => !option?.name) ? [] : referenceOptions;
    }
    return [];
  }, [referenceOptions]);

  return (
    <Modal show={show} size="md" backdrop="static" aria-labelledby="contained-modal-title-vcenter" className="common-custom-modal modal-medium">
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title id="contained-modal-title-vcenter">{t('SUPPORTING_DOCUMENTS.EDIT_MODAL_TITLE')}</Modal.Title>
          <span onClick={handlePopup} className="icon-close cursor-pointer" />
        </div>
      </Modal.Header>
      <Modal.Body>
        {showLoader ? (
          <Loader />
        ) : (
          <>
            <div className="modal-inner-data">
              <FormGroup>
                <label className="asterisk-req">
                  {t('SUPPORTING_DOCUMENTS.DOCUMENT_NAME')}
                  <span>*</span>
                </label>
                <div className="input-group common-input-control fixed-label">
                  <input
                    type="text"
                    name="fileName"
                    {...register('fileName', {
                      required: true,
                      validate: (value) => !!value.trim() || t('EDIT_SUPPORTING_DOCUMENT.NO_SPACE'),
                    })}
                    placeholder={t('SUPPORTING_DOCUMENTS.DOCUMENT_NAME')}
                    className="form-control"
                  />
                </div>
                {errors.fileName && <small className="error-message">{t('EDIT_SUPPORTING_DOCUMENT.REQUIRED_FIELD')}</small>}

                {!fromColourLibrary && (
                  <>
                    <div className="mt-3 asterisk-req">{t('ADD_SUPPORTING_DOCUMENT.REFERENCE')}</div>
                    <div className="common-react-select">
                      <Select
                        name="reference"
                        options={validReferenceOptions}
                        getOptionLabel={(option) => `${option?.name}`}
                        getOptionValue={(option) => `${option?._id}`}
                        value={reference}
                        styles={customStyles}
                        onChange={handleReference}
                        placeholder={t('ADD_SUPPORTING_DOCUMENT.REFERENCE')}
                        isClearable
                        className="common-select"
                        classNamePrefix="common-select"
                      />
                    </div>

                    <div className="mt-3 asterisk-req">{t('ADD_SUPPORTING_DOCUMENT.PLACEMENT')}</div>
                    <div className="common-react-select">
                      <Select
                        name="placement"
                        options={placement_master}
                        getOptionLabel={(option) => `${option?.name}`}
                        getOptionValue={(option) => `${option?._id}`}
                        value={placement}
                        styles={customStyles}
                        onChange={handlePlacement}
                        placeholder={t('ADD_SUPPORTING_DOCUMENT.PLACEMENT')}
                        isClearable
                        className="common-select"
                        classNamePrefix="common-select"
                      />
                    </div>
                  </>
                )}
              </FormGroup>
            </div>
            <div className="common-model-footer">
              <button aria-label="Submit" title={t('EDIT_SUPPORTING_DOCUMENT.SUBMIT')} onClick={handleSubmit(onSubmit)} type="button" className="btn p-0">
                <i className="icon-Tick-1 f-24" />
              </button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default EditSupportingDocument;
